<template>
<div style="display: flex; align-items: center">
    <div class="copy_setting" @click="openDialog">
      <svg-icon icon-class="setting"></svg-icon>{{$t("设置#!!!#src/pages/H5/Cloud/components/share/FileShareCopySetting.vue_1")}}    </div>
    <!-- 分割线 -->
    <div class="split_line"></div>
    <!-- 弹窗 -->
    <moo-dialog custom-class="common-dialog file_share_copy_setting_dialog" :append-to-body="true" :title="$t('权限设置#!!!#src/pages/H5/Cloud/components/share/FileShareCopySetting.vue_2')" :visible.sync="showDialog" width="480px">
      <div class="dialog_title">
        <div>{{$t("权限设置#!!!#src/pages/H5/Cloud/components/share/FileShareCopySetting.vue_1")}}</div>
        <div class="close-btn" @click="closeShareView">
          <img src="@/assets/h5/file/icon_file_close.png">
        </div>
      </div>
      <div class="who_can_copy">
        <div style="font-weight: 500">{{$t("谁可以复制内容#!!!#src/pages/H5/Cloud/components/share/FileShareCopySetting.vue_1")}}</div>
        <moo-dropdown v-model="copyPermission" trigger="click" slot="dropdown" @visible-change="handleDropdownVisibleChange" @command="handlerChangeAuth">
          <button class="file_share_copy_setting_dialog_button">
            <span>              {{loading
  ? $t(
      '加载中...#!!!#src/pages/H5/Cloud/components/share/FileShareCopySetting.vue_1'
    )
  : copyPermissionList.find(item => item.id === copyPermission).name}}            </span>
            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAMCAMAAABYzB2OAAAAAXNSR0IArs4c6QAAAH5QTFRFAAAAAAD/AAAAgICAVVVVgICAgICAYGCAZmaAYmJ2aGh0ZWtxaG1yZWxzZWxyZWt0ZGpyZGt0ZWlyZGpzY2pyZGp0Y2tyZGpzZWpzZml0ZWp1ZGp0Y2lzZGpzZWt0Y2p0ZGp0ZGpzZGpzZGpyZGpzZGtzZGpzZGpzZGpzZGpz+kw2rQAAACl0Uk5TAAEBAgMEBggKDRYrMUdTVldwcnN0hIiMjo+QkaepqrbN2PT1+Pn6/f5giBxDAAAAkklEQVR42kXPyxKCMAyF4UNSCi24A3R8/7dDF9wGxV5sMzJ21f79sggAIpxHrmz1UcSzBG3g+d75nVOUUvX98aIdQ+dllEM9XJwDb2ybuCWXzLV9P2dmWnVtio0omfbzmJRP34vKLoqZlANHoqWsbXC3JpnSAYxYxFUZ3dpDTE7IrrIqjGIkiQOPs5j/ImzAv8cXuDlCnM1rRwMAAAAASUVORK5CYII=" :style="{
                transform: dropdownVisible ? 'rotate(180deg)' : 'rotate(0deg)',
              }">
          </button>
          <moo-dropdown-menu slot="dropdown" class="file_share_copy_setting_dropdown">
            <div class="permission-list" v-for="(permission, i) in copyPermissionList" :key="i">
              <moo-dropdown-item :command="i">
                <div class="permission-name">
                  {{ permission.name }}
                  <img class="permission-selected-icon" v-show="permission.id === copyPermission" src="@/assets/h5/file/icon_file_selected.png">
                </div>
              </moo-dropdown-item>
            </div>
          </moo-dropdown-menu>
        </moo-dropdown>
      </div>
    </moo-dialog>
  </div>
</template>

<script>
import { intl } from 'tci18n-vue2'
import { mapActions, mapState } from "vuex";
import { COPY_PERMISSION } from "@/constants/file";
import { getCopyAuth, setCopyAuth } from "@/api/h5/file";

export default {
  name: "FileShareCopySetting",
  props: {
    fileId: { type: String }
  },
  data() {
    return {
      copyPermissionList: COPY_PERMISSION,
      showDialog: false,
      dropdownVisible: false,
      loading: false
    };
  },
  mounted() {
    this.loading = true;
    getCopyAuth(this.fileId).
    then((res) => {
      if (res.code === 200) {
        const { copyEntity } = res.data;
        this.setCopyPermission(copyEntity);
      }
    }).
    catch((err) => {
      this.$message({ message: intl.$t("获取复制权限失败#!!!#src/pages/H5/Cloud/components/share/FileShareCopySetting.vue_1"), type: "error" });
    }).finally(() => {
      this.loading = false;
    });
  },
  computed: {
    ...mapState({
      copyPermission: (state) => state.copyPermission
    })
  },
  methods: {
    ...mapActions({
      setCopyPermission: "setCopyPermission"
    }),
    openDialog() {
      this.showDialog = true;
    },
    closeShareView() {
      this.showDialog = false;
    },
    handleDropdownVisibleChange(visible) {
      this.dropdownVisible = visible;
    },
    handlerChangeAuth(index) {
      const currentPermission = this.copyPermission;
      const selectedPermission = this.copyPermissionList[index];
      // 设置后立即生效
      this.setCopyPermission(selectedPermission.id);
      setCopyAuth(this.fileId, {
        copyEntity: selectedPermission.id
      }).
      then((res) => {
        if (res.code === 200) {
          this.$message({ message: intl.$t("操作成功#!!!#src/pages/H5/Cloud/components/share/FileShareCopySetting.vue_1"), type: "success" });
        } else {
          this.$message({
            message: intl.$t(`操作失败，{slot0}#!!!#src/pages/H5/Cloud/components/share/FileShareCopySetting.vue_1`, { slot0: res.message }),
            type: "error"
          });
          this.setCopyPermission(currentPermission);
        }
      }).
      catch((err) => {
        this.$message({ message: intl.$t("操作失败，#!!!#src/pages/H5/Cloud/components/share/FileShareCopySetting.vue_1"), type: "error" });
        this.setCopyPermission(currentPermission);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.copy_setting {
  display: flex;
  align-items: center;
  padding: 4px 6px;
  border-radius: 4px;
  cursor: pointer;

  svg {
    width: 16px;
    height: 16px;
    margin-right: 2px;
  }

  &:hover {
    background: #f4f6f9;
  }
}
.split_line {
  width: 1px;
  height: 16px;
  margin: 0 10px;
  border-radius: 1px;
  background: #e2e6ed;
}
.dialog_title {
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
  font-weight: 600;
  font-size: 16px;
  color: #121317;
  line-height: 24px;

  .close-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 24px;
    height: 24px;
    padding: 4px;
    border-radius: 4px;
    box-sizing: border-box;

    &:hover {
      background: #f4f6f9;
    }
  }

  img {
    width: 14px;
    height: 14px;
    cursor: pointer;
  }
}
.who_can_copy {
  display: flex;
  justify-content: space-between;
}
.file_share_copy_setting_dialog_button {
  min-width: 145px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px 8px;
  border-radius: 4px;
  background: #f4f6f9;
  font-size: 14px;
  color: #121317;
  cursor: pointer;
  outline: none;
  border: none;

  span {
    max-width: 240px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  img {
    margin-left: 4px;
    width: 12px;
  }

  &:hover {
    background: #eceef2;
  }
}
</style>

<style lang="scss">
.file_share_copy_setting_dialog {
  min-height: 290px !important;
  background-color: #fff !important;
  border-radius: 10px !important;
  border: 1px solid #e6e8ec !important;
  box-shadow: 0 8px 12px 0 rgba(18, 19, 23, 0.1);
  padding: 16px !important;

  .moo-dialog__header {
    display: none !important;
  }
  .moo-dialog__body {
    padding: 0 !important;
    color: #222329;
  }
}

.file_share_copy_setting_dropdown {
  min-width: 140px;
  padding: 4px !important;

  .moo-dropdown-menu__item {
    padding: 0 8px !important;
  }

  .permission-name {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .permission-selected-icon {
    margin-left: 4px;
    width: 14px;
  }

  li {
    color: #121317 !important;
    &:hover {
      border-radius: 4px !important;
      background-color: rgb(242, 243, 245) !important;
    }
  }
}
</style>
